module.exports = __webpack_public_path__ + "img/mastercardlogo.478335ad.png";